<template>
  <div class="legacy-ticker-dialog" @click="_emitCloseComponent">
    <div class="modal-container" role="dialog" aria-modal="true" aria-label="Valores de mi cartera" @click.stop>
      <div class="modal-header">
        <div class="title-wrapper">
          <span class="material-icons-outlined header-icon" aria-hidden="true">account_balance_wallet</span>
          <h3 class="modal-title">Valores de mi cartera</h3>
        </div>
        <button type="button" class="modal-close-btn" aria-label="Cerrar valores de mi cartera" @click="_emitCloseComponent">
          <i class="material-icons" aria-hidden="true">close</i>
        </button>
      </div>
      <div class="modal-body">
        <div class="list-container">
          <button type="button" class="collection-option" @click="_redirectToWaitingsSearch()">
            <span class="material-icons-outlined" aria-hidden="true">schedule</span>
            <span>Valores en espera</span>
          </button>
          <button type="button" class="collection-option" @click="_redirectToOpenPositionsSearch()">
            <span class="material-icons-outlined" aria-hidden="true">show_chart</span>
            <span>Valores en cartera</span>
          </button>
          <button type="button" class="collection-option" @click="_redirectToStockSearch()">
            <span class="material-icons-outlined" aria-hidden="true">list</span>
            <span>Ver todos</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { legacyQueryConsumer } from "@/features/stockchart/models/legacyQuerySelection";
import { navigateLegacyQuery } from "@/features/stockchart/services/legacyQueryActivation";
    import APICaller from "@/shared/mixins/APICaller.js";
    import { mapGetters } from "vuex";

    export default{
        mixins: [legacyQueryConsumer, APICaller],
        name: "ValoresCartera",
        components:{
        },
        data: () =>({
            portfolios: [],
        }),
        created(){

        },
        watch: {
        },
        computed:{
            ...mapGetters(['_g_portfolio_id_selected'])
        },
        mounted(){
            this._getPortfolios()
        },
        methods:{
            _getPortfolios: function(){
                let success = (response) => {            
                    this.portfolios = response.data
                };
                let url = '/api/v1/portfolio/list';

                const successHandler = new APICaller.SuccessHandler(success);
                const failureHandler = new APICaller.FailureHandler('029.2', 'Error cargando las carteras de usuario.');

                this._getAPICall(url, successHandler, failureHandler);

            },
            _emitCloseComponent: function(){
                this.$emit("close-component")
            },
            _redirectToStockSearch: function(){
                navigateLegacyQuery(this, '/app/graficador-dinamico/all-values/' + this._g_portfolio_id_selected);
            },
            _redirectToWaitingsSearch: function(){
                navigateLegacyQuery(this, '/app/graficador-dinamico/waitings/' + this._g_portfolio_id_selected);
            },
            _redirectToOpenPositionsSearch: function(){
                navigateLegacyQuery(this, '/app/graficador-dinamico/open-positions/' + this._g_portfolio_id_selected);
            },
        }
    }

</script>

<style lang="scss" scoped>
@import "../styles/legacy-ticker-dialogs.scss";
.legacy-ticker-dialog .collection-option {
  display: flex; align-items: center; gap: 10px; width: 100%; min-height: 44px;
  padding: 10px 12px; border: 1px solid var(--dialog-border);
  background: var(--dialog-control); color: var(--dialog-text);
  text-align: left; font-size: 14px; font-weight: 500;
  .material-icons-outlined { font-size: 20px; color: var(--dialog-muted); }
  &:hover { background: var(--dialog-hover); border-color: var(--dialog-control-border); }
}
</style>
